import { HttpClient, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Params } from '@angular/router';

import {
  RequestParams,
  buildContext,
  buildHttpParams,
  cleanHttpParams
} from './helpers';

@Injectable({
  providedIn: 'root'
})
export abstract class AbstractService {
  protected prefix = '';

  private readonly http = inject(HttpClient);

  protected get<T>(
    url: string,
    query: any = {},
    requestParams: Partial<RequestParams> = {}
  ): Observable<T> {
    return this.http.get<T>(this.prefix + url, {
      context: buildContext(requestParams),
      params: buildHttpParams(query)
    });
  }

  protected post<T>(
    url: string,
    params: any = {},
    requestParams: Partial<RequestParams> = {},
    headers: Params | null = null
  ): Observable<T> {
    if (requestParams.cleanParams) {
      params = cleanHttpParams(params);
    }

    return this.http.post<T>(this.prefix + url, params, {
      context: buildContext(requestParams),
      headers: headers ? new HttpHeaders(headers) : undefined
    });
  }

  protected patch<T>(
    url: string,
    params: any = {},
    requestParams: Partial<RequestParams> = {}
  ): Observable<T> {
    if (requestParams.cleanParams) {
      params = cleanHttpParams(params);
    }

    return this.http.patch<T>(this.prefix + url, params, {
      context: buildContext(requestParams)
    });
  }

  protected delete<T>(
    url: string,
    requestParams: Partial<RequestParams> = {}
  ): Observable<T> {
    return this.http.delete<T>(this.prefix + url, {
      context: buildContext(requestParams)
    });
  }

  protected uploadFile<T>(
    url: string,
    file: File,
    params: any = {},
    requestParams: Partial<RequestParams> = {}
  ): Observable<HttpEvent<T>> {
    const formData = new FormData();

    formData.append('file', file);

    for (const key in params) {
      formData.append(key, params[key]);
    }

    return this.http.post<T>(this.prefix + url, formData, {
      context: buildContext(requestParams),
      reportProgress: true,
      observe: 'events'
    });
  }
}
